<template>
  <v-main class="mt-1" style="--v-layout-left: 0px;">
    <v-row class="text-left mt-4 mb-0" v-if="!$vuetify.display.mobile">
      
    </v-row>
    <v-row>
      <v-col :cols="12" class="pb-0 mb-0" v-if="!$vuetify.display.mobile">
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3" v-if="!$vuetify.display.mobile">
      </v-col>
      <v-col cols="12" md="9" v-if="!$vuetify.display.mobile">
        <h2 class="text-left my-0  mb-1 top">
          {{navigation.find(e => e.component == selectedComponent).title}}
        </h2>
      </v-col>
      <v-col cols="12" md="3" class="pa-0 right" v-if="!$vuetify.display.mobile">
        <v-list dense nav class="outline pa-3">
          <v-list-item v-for="item in navigation" :key="item.title" link
            @click=select(item.component)>
            <div class="item-wrapper d-flex align-center" :class="{'selected': selectedComponent == item.component}">
              <v-icon class="mr-2">{{ item.icon }}</v-icon>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </div>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col cols="12" md="9" class="view pa-0 pl-md-6">
        <component :is="selectedComponent"></component>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
import OverviewComponent from '@/components/OverviewComponent.vue'
import LegalComponent from '@/components/LegalComponent.vue'
import FavouritesView from '@/views/FavouritesView.vue'
import PhenotypeView from '@/views/PhenotypeView.vue'
import BookingComponent from '@/components/BookingComponent.vue'
import DepositsComponent from '@/components/DepositsComponent.vue'

export default {
  components: {
    OverviewComponent,
    FavouritesView,
    PhenotypeView,
    BookingComponent,
    DepositsComponent,
    LegalComponent
  },
  data() {
    return {
      selectedComponent: "FavouritesView"
    }
  },
  computed: {
    navigation() {
      return [
        {
          title: this.$t('page.personal_data_name'),
          icon: "mdi-widgets-outline",
          component: "OverviewComponent",
          name: "personal-details"
        },
        {
          title: this.$t('page.favorite_profiles_name'),
          icon: "mdi-heart-outline",
          component: "FavouritesView",
          name: "favourites"
        },
        {
          title: this.$t('page.phenotype_name'),
          icon: "mdi-account-multiple-outline",
          component: "PhenotypeView",
          name: "phenotype"
        },
        {
          title: this.$t('page.reservations_name'),
          icon: "mdi-plus-box-outline",
          component: "BookingComponent",
          name: "reservations"
        },
        {
          title: this.$t('page.deposits_name'),
          icon: "mdi-archive-outline",
          component: "DepositsComponent",
          name: "deposits"
        },
        {
          title: this.$t('page.legal_information_name'),
          icon: "mdi-file-document-outline",
          component: "LegalComponent",
          name: "legal-information"
        }
      ]
    }
  },
  mounted() {
    this.setSelectedComponentByRouteQuery()
  },
  watch: {
    '$route' () {
      this.setSelectedComponentByRouteQuery()
    }
  },
  methods: {
    select(component) {
      this.$router.push(
        {
          name: 'dashboardView',
          query: {
            selected: this.navigation.find(e => e.component == component).name
          }
        }
      )
      this.selectedComponent = component;
    },
    setSelectedComponentByRouteQuery() {
      let selected = this.$route.query.selected;
      let navElement = this.navigation.find(e => e.name == selected);
      if(selected && navElement) {
        this.selectedComponent = navElement.component;
      }
    }
  }
}

</script>

<style lang="scss" scoped>
// this is just stupid, WHY include
// default margin that goes beyond
// set boundaries... we should NOT
// have to do that
.v-row {
  margin: 0;
  padding: 0;
}
.item-wrapper {
  @include nsb-select-option;
  font-size: 14px;
  line-height: 21px;
}
.outline {
  box-sizing: border-box;
  border: 1px solid $nsb-color-3;
}
.top {
  @include nsb-font-main-header;
  font-size: 28px;
  line-height: 32px;
  font-weight: normal;
}

  .crumb {
    // width: 100%;
    text-align: left;
    @include nsb-font-header;
    font-size: 10px;
    line-height: 15px;
    color: $nsb-disabled-text;
    .current {
      @include nsb-font-header-bold;
      font-size: 10px;
      line-height: 15px;
      color: $ds-primary;
    };
  }

  .selected {
    @include nsb-select-sublabel;
    color: $ds-primary;
    font-size: 14px;
    line-height: 21px;
  }
  .right {
    max-width: 282px;
  }
  .view {
    margin: 0;
  }
</style>